import type { SerializableDynamicValue } from "~/Configurators/common/v2/types";

export const MetricShaftDefaultValues: Record<string, SerializableDynamicValue<string>> = {
  VWST_060: [
    {
      condition: {
        type: "equals",
        cstic: "VMKB_060",
        value: "WH",
      },
      value: "C60",
    },
    "CF53",
  ],
  VBSCH060: "/",
  VTOL_060: "H6",
  VLMAX_01A_060: "LN",
  VBEAL060: "005",
  VBEAM060: "900",
  VBEAR060: "005",
};
